const getters = {
  loginUserInfo: state => state.user.userInfo,
  token: state => state.user.userInfo ? state.user.userInfo.token : null,
  mobile: state => state.user.userInfo ? state.user.userInfo.mobile : null,
  userType: state => state.user.userInfo ? state.user.userInfo.type : null,
  menuList: state => state.user.userInfo ? state.user.userInfo.menuList : null,
  organizationList: state => state.user.userInfo ? state.user.userInfo.organizationList : null,
  themeColor: state => state.permission.themeColor,
  collapse: state => state.permission.collapse,
  menuUrl: state => state.permission.menuUrl,
  isFullscreen: state => state.app.isFullscreen
};

export default getters;
